import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'

function* getTisaForexRateCategorySaga(action: ActionModel) {
  try {
    const params: any = action.payload?.params
    yield delay(500)
    const response: ResponseModel = yield call(service.getTisaForexRateCategory, params)
    const data: any = response?.data
    yield put(actions.getTisaForexRateCategorySuccess(data))
  } catch (error: any) {
    yield put(actions.getTisaForexRateCategoryError(error))
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_TISA_FOREX_RATE_CATEGORY_START, getTisaForexRateCategorySaga)
}
